var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4848 0C17.3089 0 22.0303 4.72136 22.0303 10.5455C22.0303 16.3696 17.3089 21.0909 11.4848 21.0909C5.66075 21.0909 0.939392 16.3696 0.939392 10.5455C0.939392 4.72136 5.66075 0 11.4848 0ZM17.6762 15.4242C17.8269 15.2727 17.9115 15.0678 17.9115 14.8541C17.9115 14.6405 17.8269 14.4355 17.6762 14.2841L15.612 12.2203C15.4604 12.0695 15.2554 11.9849 15.0416 11.9849C14.8279 11.9849 14.6228 12.0695 14.4713 12.2203L13.9104 12.7815C13.7241 12.9693 13.4822 13.092 13.2205 13.1311C12.9589 13.1703 12.6917 13.1239 12.4585 12.9989C10.9988 12.2258 9.80489 11.032 9.03155 9.57235C8.90649 9.33917 8.86006 9.07185 8.89917 8.81016C8.93829 8.54848 9.06086 8.30641 9.24863 8.12L9.81063 7.55895C9.96131 7.40743 10.0459 7.20242 10.0459 6.98873C10.0459 6.77504 9.96131 6.57004 9.81063 6.41852L7.7464 4.35494C7.59488 4.20417 7.38982 4.11952 7.17606 4.11952C6.9623 4.11952 6.75724 4.20417 6.60572 4.35494C6.52041 4.44001 6.41248 4.54278 6.29706 4.65153C6.00842 4.92436 5.64831 5.26391 5.50273 5.47738C4.736 6.59944 5.10369 8.1006 5.54541 9.16248C6.12891 10.5621 7.2043 12.0872 8.57459 13.4565C9.94365 14.8257 11.4682 15.9012 12.8686 16.4847C13.9303 16.9271 15.4309 17.2938 16.5529 16.5273C16.7662 16.3816 17.1063 16.0223 17.3786 15.7333C17.4878 15.6181 17.5906 15.5092 17.6762 15.4242Z",
    fill: "#546EDB",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTel);
export default __webpack_public_path__ + "static/media/tel.79ae4fe6b932aacc5a3e36a904843891.svg";
export { ForwardRef as ReactComponent };